'use client';

import PropTypes from 'prop-types';

import {Link} from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import ListItemText from "@mui/material/ListItemText";

import Iconify from 'src/components/iconify';

function RecipeOverview({recipeData}) {
  const overviewItems = [];

  if (recipeData.forHowManyPersonLabel) {
    overviewItems.push({
      label: 'Dla ilu osób',
      value: recipeData.forHowManyPersonLabel,
      icon: <Iconify icon="solar:users-group-rounded-bold" />,
    })
  }

  if (recipeData.mealTypes) {
    overviewItems.push({
      label: 'Typ posiłku',
      value: recipeData.mealTypes.map(mealType => mealType.name).join(', '),
      icon: <Iconify icon="solar:clock-circle-bold" />,
    })
  }

  if (recipeData.timeConsumingLabel) {
    overviewItems.push({
      label: 'Czas przygotowania',
      value: recipeData.timeConsumingLabel,
      icon: <Iconify icon="solar:clock-circle-bold" />,
    })
  }

  if (recipeData.sourceRecipeUrl) {
    overviewItems.push({
      label: 'Przepis źródłowy',
      value: <Link href={recipeData.sourceRecipeUrl} target="_blank" rel="noopener">{recipeData.sourceRecipeUrl}</Link>,
      icon: <Iconify icon="solar:link-linear" />,
    })
  }

  return (
    <Box
      gap={3}
      display="grid"
      gridTemplateColumns={{
        xs: 'repeat(1, 1fr)',
        md: 'repeat(2, 1fr)',
      }}
    >
      {overviewItems.map((item) => (
        <Stack key={item.label} spacing={1.5} direction="row">
          {item.icon}
          <ListItemText
            primary={item.label}
            secondary={item.value}
            primaryTypographyProps={{
              typography: 'body2',
              color: 'text.secondary',
              mb: 0.5,
            }}
            secondaryTypographyProps={{
              typography: 'subtitle2',
              color: 'text.primary',
              component: 'span',
            }}
          />
        </Stack>
      ))}
    </Box>
  );
}

RecipeOverview.propTypes = {
  recipeData: PropTypes.object
}

export default RecipeOverview;
